import request from '@/config/axios'

export const getByStudentId = async (params: any): Promise<IResponse> => {
  const res = await request.get({
    url: '/studentTestGrades/getByStudentId',
    params
  })
  return res
}

export const listApi = ({
  class_id,
  class_roll_call_id = undefined,
  student_test_ids = undefined
}) => {
  return async (params: any): Promise<IResponse> => {
    const res = await request.get({
      url: `/studentTestGrades/list`,
      params: { ...params, class_id, class_roll_call_id, student_test_ids }
    })
    return res
  }
}

export const saveApi = async (data: Partial<TableData>): Promise<IResponse> => {
  if (data.id) {
    return await request.put({ url: `/studentTestGrades/${data.id}`, data })
  } else {
    return await request.post({ url: '/studentTestGrades', data })
  }
}

export interface ExamEntry {
  grade: number | null
  classAverage: number | null
  classRank: number | null
  unregistered: boolean
}

export interface FailingListResponse {
  examHeaders: string[]
  students: { id: number; name: string; className: string; grades: Record<string, ExamEntry> }[]
  totalCount: number
  failingCounts: Record<string, number>
}

export const getFailingListApi = async (params: {
  teacher_id: string | number
  school_year?: string | number
  grade_label?: string
  semester_label?: string
}): Promise<FailingListResponse> => {
  return request.get<FailingListResponse>({
    url: '/studentTestGrades/failingList',
    params
  })
}

export default {
  getByStudentId,
  saveApi,
  listApi,
  getFailingListApi
}
